export const RESOURCE_LANDINGS = [
  {
    slug: "meditacion-corazon-helicoidal",
    eyebrow: "Meditación guiada",
    title: "Meditación del Corazón Helicoidal",
    cardTitle: "Meditación del Corazón",
    pageTitle: "Meditación del Corazón",
    short: "Una experiencia guiada para conectar con tu interior, bajar el ruido y sentir un poco más de claridad en pocos minutos.",
    subtitle: "Una experiencia guiada para conectar contigo, bajar el ruido y escuchar lo que tu interior lleva tiempo queriendo decirte.",
    cta: "Escuchar",
    dark: true,
    minimal: true,
    lockedText: [
      "Para escuchar la meditación necesitas crear tu cuenta gratuita.",
      "Una vez dentro de tu área privada podrás acceder al audio siempre que lo necesites.",
      "Tu proceso es privado y solo tú verás lo que escribas.",
    ],
    details: {
      intro: ["Esta meditación te acompaña cuando sientes vacío, desconexión, sensibilidad o confusión, y te ayuda a recuperar presencia, claridad emocional y una sensación más profunda de dirección interna."],
      outro: "Puedes usarla en cualquier momento del día, incluso si nunca has meditado antes.",
    },
    // Set paths when ready, e.g. "/media/meditacion-intro.mp4" and "/audio/meditacion-corazon-helicoidal.mp3".
    media: { video: "", audio: "" },
  },
  {
    slug: "pack-iniciacion",
    eyebrow: "Pack de iniciación",
    title: "Pack de Iniciación Heartmony",
    short: "Tu kit completo para empezar el camino: 20 meditaciones, 40 audios subliminales y el resumen del libro La Energía del Corazón.",
    cta: "Acceder al pack",
    dark: true,
    subtitle: "Tu kit esencial para empezar a conectar con tu corazón y avanzar con claridad.",
    details: {
      intro: ["El Pack de Iniciación Heartmony reúne todo lo que necesitas para empezar tu camino interior con claridad y acompañamiento.", "Incluye:"],
      bullets: [
        "20 meditaciones guiadas para activar tu sensibilidad, ordenar tu energía y entender lo que sientes.",
        "40 audios subliminales (20 silenciosos y 20 con música) diseñados para reprogramar tu interior desde la coherencia del corazón.",
      ],
      outro: ["Es un kit completo, práctico y transformador.", "Puedes usarlo en cualquier momento del día, a tu ritmo, y desde cualquier nivel de experiencia."],
    },
    // Add audio items as { title: "...", src: "/audio/pack/..." } when ready.
    media: {
      collections: [
        { id: "meditaciones", title: "Meditaciones guiadas", total: 20, items: [] },
        { id: "subliminales-silenciosos", title: "Subliminales silenciosos", total: 20, items: [] },
        { id: "subliminales-musica", title: "Subliminales con música", total: 20, items: [] },
      ],
    },
  },
  {
    slug: "resumen-la-energia-del-corazon",
    eyebrow: "Resumen del libro",
    title: "Resumen del libro ‘La Energía del Corazón’",
    cardTitle: "8 claves para recuperar la coherencia",
    pageTitle: "8 claves para recuperar la coherencia",
    dark: true,
    minimal: true,
    lockedText: [
      "Para acceder al Ebook necesitas crear tu cuenta gratuita.",
      "Una vez dentro de tu área privada podrás descargarlo y guardarlo para ti.",
      "Tu proceso es privado y solo tú verás lo que escribas.",
    ],
    details: {
      intro: [
        "Este recurso es una guía breve y profunda para acompañarte cuando sientes vacío, desconexión, sensibilidad o confusión.",
        "Las 8 claves te ofrecen una hoja de ruta sencilla para recuperar coherencia, bajar el ruido y empezar a escuchar tu interior con más claridad.",
      ],
    },
    // Set the PDF path when ready, e.g. "/docs/8-claves-coherencia.pdf".
    media: { pdf: "" },
    short: "Una síntesis clara de los principios que sostienen Heartmony y que te ayudan a entender este momento sin miedo.",
    cta: "Descargar",
  },
];
